export default {"src":"/_next/static/media/consult-service.648952b8.svg","height":368,"width":396,"blurWidth":0,"blurHeight":0};